export enum ViewingOption {
	Private = 'private',
	Public = 'public',
	None = 'none',
}
